import React from "react";
import CustomText from "../atomic/CustomText";
import CustomCheckBox from "../atomic/CustomCheckBox";
import CustomTextInput from "../global/CustomTextInput";
import CustomRadioInput from "../molecular/CustomRadioInput";

const SHIPMENT_METHODS = [
  "FedEx",
  "USPS",
  "UPS",
  "DHL",
  "Private Courier",
  "Hand-Delivered",
];

const SHIPMENT_METHOD_OPTIONS = SHIPMENT_METHODS.map((method) => ({
  label: method,
  value: method,
}));

const ShipmentInformationFields = ({ values = {}, setFieldValue }: any) => {
  const isTissueShipped = !!values.isTissueShipped;

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setFieldValue("isTissueShipped", isChecked);

    // Reset other fields if unchecked
    if (!isChecked) {
      setTimeout(() => {
        setFieldValue("shipTracking", "");
        setFieldValue("shipMethod", "");
      }, 0);
    }
  };

  // Set default shipment method to 'FedEx' if not already set
  React.useEffect(() => {
    if (isTissueShipped && !values.shipMethod) {
      setFieldValue("shipMethod", "FedEx");
    }
  }, [isTissueShipped, values.shipMethod, setFieldValue]);

  return (
    <div className="bg-white p-6 shadow-md rounded-md hover:border-primary border  flex flex-col">
      <div className="flex items-center mb-4">
        <CustomCheckBox
          id="isTissueShipped"
          name="isTissueShipped"
          value={values.isTissueShipped}
          checked={isTissueShipped}
          label="Sample shipped - No shipping airbill or material request needed."
          onClick={handleCheckboxChange}
        />
      </div>

      {isTissueShipped && (
        <div className="flex flex-wrap md:flex-row gap-4 md:gap-8 items-start">
          <div className="flex flex-col flex-1 max-w-xs">
            <CustomText
              text="Shipment Tracking Number"
              fontWeight="font-semibold"
              className="inputLabel"
            />
            <CustomTextInput
              placeholder="Enter tracking number"
              roundedInput
              onChange={(e) => setFieldValue("shipTracking", e.target.value)}
              value={values.shipTracking ?? ""}
              className=" bg-white !border-[#BFC7CE] w-full"
            />
          </div>
          <div className="flex">
            <CustomRadioInput
              labelInfo={{ label: "Shipment Method", required: true, inputId: "shipMethod" }}
              name="shipMethod"
              options={SHIPMENT_METHOD_OPTIONS.map((opt) => ({
                id: opt.value,
                label: opt.label,
                value: opt.value,
              }))}
              values={values}
              setFieldValue={setFieldValue}
              setFieldTouched={() => {}}
              manualFieldsChangeOnOptionClick={(option, setFieldValue, setFieldTouched) => {
                setFieldValue("shipMethod", option.value);
                return {};
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipmentInformationFields;
